var refine = {

	init: function () {
		refine.toggle();
	},

	toggle: function () {
		$('.m-refine:not(.js-side-nav-done)').each(function () {
			var wrapper = $(this);
			var allow = true;
			var title = wrapper.find('.js-refine-title');
			var menu = wrapper.find('.js-refine-content');

			// click
			title.off('click').on('click', function () {
				if (!allow || Modernizr.mq('(min-width:' + site.bp.tabletLarge + 'px)')) return false;
				allow = false;
				title.toggleClass('active');
				menu.slideToggle(250, function () {
					allow = true;
				});
				return false;
			});

			// done
			wrapper.addClass('js-side-nav-done');
		});
	}

}

$(function () {
	refine.init();
	site.doc.ajaxComplete(function () {
		refine.init();
	});
});